export const mergeForMePreviews = (initialPreviews, feedPreviews, dismissedInitialIds = {}, excludedIds = {}) => {
    const picked = Array.isArray(initialPreviews)
        ? initialPreviews.filter(preview => !dismissedInitialIds[preview?.id]) : [];
    const feed = Array.isArray(feedPreviews) ? feedPreviews : [];
    const ids = new Set();
    return [...picked, ...feed].filter(preview => {
        if (!preview?.id || ids.has(preview.id) || excludedIds[preview.id]) return false;
        ids.add(preview.id);
        return true;
    });
};
